export function getBrandInitials(brand) {
  const brandName = brand?.name;
  return (brandName && `${brandName.charAt(0)}${brandName.charAt(1)}`.toUpperCase()) || '';
}
